var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Loading"},[_c('div',{staticClass:"tanchuang"},[_c('div',{staticClass:"tubiao"}),_c('div',{staticClass:"buyVip"},[_vm._v("报告加载中 ···")])])])
}]

export { render, staticRenderFns }